import BaseApiRequest from "./BaseApiRequest";
import { CREATE_APPLICATION } from "../ApiUrls";
import { METHOD, S_STAFF_ID } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class CreateApplication extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {
    firstName: "",
    middleName: "",
    surname: "",
    dateOfBirth: "",
    city: "",
    state: "",
    postalCode: "",
    fingerprint: "",
    branch: "",
    bundleProductId: "",
  };

  constructor(applicationDetails) {
    super();
    const request = applicationDetails;
    delete request.message;
    this.body = {
      ...this.body,
      ...request,
      staffId: sessionStorage.getItem(S_STAFF_ID),
    };
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(CREATE_APPLICATION);

  getBody = () => this.body;
}
